export enum SwitcherEnum {
  SHOW_ME = 0,
  HIDE_ME = 1,
  ALL = 2,
  UNREAD = 3,
}
